var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-manage"},[_c('statistics'),_c('file-list'),_c('edit-modal'),_c('delete-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }